import React from "react";
import { Row, Col, Container, ListGroup } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaMobileAlt,
  AiFillCopyrightCircle,
} from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import { withRouter } from "react-router-dom";

const Footer = (props) => {
  const data = props.data;
  const scrollTo = (e, id) => {
    e.preventDefault();

    const { pathname } = props.location;

    if (pathname === "/") {
      document.getElementById(id).scrollIntoView();
    } else {
      props.history.push("/");
    }
  };
  return (
    <section id="footer">
      <Row className="row1">
        <Col md={4}>
          <h5>ABOUT US</h5>
          <p>{data.fiveStarslogans || ""}</p>
        </Col>
        <Col md={4}>
          <h5>IMPORTANT LINKS</h5>
          <p>
            <a href="https://fivestaruniverse.net">Home</a>
          </p>
          {/* <p><Link to="/" onClick={(e)=>scrollTo(e,'services')}>Services</Link></p>
                <p><Link to="/" onClick={(e)=>scrollTo(e,'mobileapps')}>Download App</Link></p>
                <p><Link to="/" onClick={(e)=>scrollTo(e,'getInTouch')}>Get a Quote</Link></p>
                <p><Link to="/#/order">Order Dumpster</Link></p> */}
        </Col>
        <Col md={4}>
          <h5>CONTACT US</h5>
          <ListGroup variant="flush">
            <ListGroup.Item></ListGroup.Item>
            <ListGroup.Item>
              <FaMapMarkerAlt /> {data.linkedinLink}
            </ListGroup.Item>
            <ListGroup.Item>
              <FaEnvelope /> <a href={`mailto:${data.email}`}>{data.email}</a>
            </ListGroup.Item>
            <ListGroup.Item>
              <FaMobileAlt /> <a href={`tel:${data.phone}`}>{data.phone}</a>
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
      <Row className="row2">
        <Col>
          <p style={{ textAlign: "left" }}>
            Copyright © 2020 Five Star Universe. All Rights Reserved.
          </p>
        </Col>
      </Row>
    </section>
  );
};

export default withRouter(Footer);
